<div class="saved-views-wrapper">
    <fd-popover
            [(isOpen)]="isOpen"
            [disabled]="disabled"
            [placement]="'bottom-start'"
            [triggers]="[]"
            [closeOnOutsideClick]="true">
        <fd-popover-control>
            <button fd-button
                    class="filter-view-button"
                    [disabled]="disabled"
                    (click)="toggleMenu()"
                    [title]="'Select filter view'"
                    i18n-title="XTOL|Filter view button tooltip@@advancedSearch.filterView.tooltip">
                <span class="button-text">{{ currentViewName }}</span>
                <app-icon icon="angle-down" size="sm"></app-icon>
            </button>
        </fd-popover-control>
        <fd-popover-body>
            <div class="saved-views-dropdown">
                <div class="saved-views-header">
                    <span i18n="XTIT|Saved views header@@advancedSearch.savedViews.header">Saved Views</span>
                </div>

                <div class="saved-views-content">
                    <ul class="saved-views-list">
                        <li *ngFor="let view of savedViews"
                            class="saved-view-item"
                            [class.is-selected]="view.name === currentViewName">
                            <button class="view-button" (click)="onViewSelected(view)">
                                {{ view.name }}
                            </button>
                        </li>
                    </ul>
                </div>

                <div class="saved-views-footer">
                    <button class="manage-button" (click)="onManageClick()">
                        <span i18n="XBUT|Manage views button@@advancedSearch.savedViews.manage">Manage</span>
                    </button>
                </div>
            </div>
        </fd-popover-body>
    </fd-popover>
</div>
